import { de_CompleteImportAutoTestConfigurationCommand, se_CompleteImportAutoTestConfigurationCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
/**
 * This route is for PSEF -> APIv2, and only allows service users. It is used to
 * copy assignments (aka import).
 * @example
 * Use a bare-bones client and the command you need to make an API call.
 * ```javascript
 * import { Apiv2Client, CompleteImportAutoTestConfigurationCommand } from "@codegrade/apiv2-client"; // ES Modules import
 * // const { Apiv2Client, CompleteImportAutoTestConfigurationCommand } = require("@codegrade/apiv2-client"); // CommonJS import
 * const client = new Apiv2Client(config);
 * const input = { // CompleteImportAutoTestConfigurationRequest
 *   assignmentId: "STRING_VALUE", // required
 *   dstAssignmentId: "STRING_VALUE", // required
 *   rubricConfiguration: { // CompleteImportAutoTestConfigurationRubricConfiguration
 *     mapping: [ // RubricMappingList // required
 *       { // RubricMapping
 *         sourceRubricRowId: Number("int"), // required
 *         destinationRubricRowId: Number("int"), // required
 *       },
 *     ],
 *     lockId: "STRING_VALUE", // required
 *   },
 * };
 * const command = new CompleteImportAutoTestConfigurationCommand(input);
 * const response = await client.send(command);
 * // {};
 *
 * ```
 *
 * @param CompleteImportAutoTestConfigurationCommandInput - {@link CompleteImportAutoTestConfigurationCommandInput}
 * @returns {@link CompleteImportAutoTestConfigurationCommandOutput}
 * @see {@link CompleteImportAutoTestConfigurationCommandInput} for command's `input` shape.
 * @see {@link CompleteImportAutoTestConfigurationCommandOutput} for command's `response` shape.
 * @see {@link Apiv2ClientResolvedConfig | config} for Apiv2Client's `config` shape.
 *
 * @throws {@link InternalServerError} (server fault)
 *  An internal failure at the fault of the server.
 *
 * @throws {@link BadRequestError} (client fault)
 *  An error at the fault of the client sending invalid input.
 *
 * @throws {@link NotFoundError} (client fault)
 *  An error due to the client attempting to access a missing
 * resource.
 *
 * @throws {@link NotAuthorizedError} (client fault)
 *  An error due to the client not being authorized to access the
 * resource.
 *
 * @throws {@link NotAuthenticatedError} (client fault)
 *  An error due to the client not being authenticated.
 *
 * @throws {@link ValidationError} (client fault)
 *  A standard error for input validation failures.
 * This should be thrown by services when a member of the input structure
 * falls outside of the modeled or documented constraints.
 *
 * @throws {@link Apiv2ServiceException}
 * <p>Base exception class for all service exceptions from Apiv2 service.</p>
 *
 *
 * @public
 */
export class CompleteImportAutoTestConfigurationCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("Apiv2", "CompleteImportAutoTestConfiguration", {})
    .n("Apiv2Client", "CompleteImportAutoTestConfigurationCommand")
    .f(void 0, void 0)
    .ser(se_CompleteImportAutoTestConfigurationCommand)
    .de(de_CompleteImportAutoTestConfigurationCommand)
    .build() {
}
